module.exports = __webpack_public_path__ + "img/health-data.1e8780c4.png";